import React, { Component } from 'react';
import * as moment from 'moment';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import Status from '../../../../config/OrderStatusConstants.js'
import { Button, } from 'semantic-ui-react'

export class UpdateStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }


    

    updateStatus = () =>{
        console.log("funk1 ++++: updateStatus");
        console.log("funk12 email:"+this.props.user.email);
        console.log("funk13 status:"+this.props.status);

        FbUtils.updateStatus(this.props.orderId, this.props.status, this.props.user.email);
    }

    render() { 
        return ( 
            <Button onClick={this.updateStatus}> {this.props.status} </Button>
         )
    }
}
 
export default UpdateStatus;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/UpdateStatus/UpdateStatus.js